module.exports = __webpack_public_path__ + "static/media/smiley-green.c36b51e5.svg";